// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * AppLauncher - Odoo-style organized module launcher
 * Full-screen overlay with domain-grouped grid navigation
 */

/* ── Overlay ── */
.app-launcher-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.app-launcher-overlay.open {
  pointer-events: all;
  opacity: 1;
}

/* Backdrop */
.app-launcher-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
}

/* ── Panel ── */
.app-launcher-panel {
  position: relative;
  z-index: 1;
  width: min(860px, 96vw);
  max-height: 88vh;
  margin-top: 5vh;
  background: var(--bg-surface, #0d0f1a);
  border: 1px solid var(--border, rgba(255,255,255,.07));
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5), 0 4px 16px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform: translateY(-12px) scale(0.98);
  transition: transform 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.app-launcher-overlay.open .app-launcher-panel {
  transform: translateY(0) scale(1);
}

/* ── Header ── */
.launcher-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border, rgba(255,255,255,.07));
  background: var(--bg-toolbar, rgba(255,255,255,.03));
  flex-shrink: 0;
}

.launcher-search-wrap {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--bg-input, rgba(255,255,255,.05));
  border: 1.5px solid var(--border, rgba(255,255,255,.12));
  border-radius: 10px;
  padding: 0 0.75rem;
  transition: border-color 0.15s;
}

.launcher-search-wrap:focus-within {
  border-color: var(--accent, #6366f1);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.launcher-search-icon {
  width: 18px;
  height: 18px;
  color: var(--text-muted, rgba(255,255,255,.35));
  flex-shrink: 0;
}

.launcher-search-input {
  flex: 1 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.95rem;
  color: var(--text-primary, #e2e8f0);
  padding: 0.55rem 0;
  font-family: inherit;
}

.launcher-search-input::placeholder {
  color: var(--text-muted, rgba(255,255,255,.35));
}

/* Remove default search cancel button */
.launcher-search-input::-webkit-search-cancel-button {
  display: none;
}

.launcher-search-clear {
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  color: var(--text-muted, rgba(255,255,255,.35));
  display: flex;
  align-items: center;
  border-radius: 4px;
  transition: color 0.15s, background 0.15s;
}

.launcher-search-clear:hover {
  color: var(--text-secondary, rgba(255,255,255,.55));
  background: var(--bg-toolbar, rgba(255,255,255,.08));
}

.launcher-search-clear svg {
  width: 16px;
  height: 16px;
}

.launcher-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: none;
  border: 1.5px solid var(--border, rgba(255,255,255,.12));
  border-radius: 8px;
  cursor: pointer;
  color: var(--text-secondary, rgba(255,255,255,.55));
  flex-shrink: 0;
  transition: all 0.15s;
}

.launcher-close-btn:hover {
  background: rgba(239,68,68,.15);
  border-color: #ef4444;
  color: #fca5a5;
}

.launcher-close-btn svg {
  width: 18px;
  height: 18px;
}

/* ── Body ── */
.launcher-body {
  overflow-y: auto;
  padding: 1.25rem 1.25rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.launcher-body::-webkit-scrollbar {
  width: 6px;
}

.launcher-body::-webkit-scrollbar-track {
  background: transparent;
}

.launcher-body::-webkit-scrollbar-thumb {
  background: var(--border, rgba(255,255,255,.14));
  border-radius: 3px;
}

/* ── Sections ── */
.launcher-section {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.launcher-section-label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--text-muted, rgba(255,255,255,.35));
  letter-spacing: 0.8px;
  text-transform: uppercase;
  padding-bottom: 0.35rem;
  border-bottom: 1px solid var(--border, rgba(255,255,255,.07));
}

.launcher-section-label.recents {
  color: var(--text-secondary, rgba(255,255,255,.55));
}

.section-label-icon {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
}

.section-label-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--domain-color, #94a3b8);
  flex-shrink: 0;
}

/* ── Grid ── */
.launcher-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 0.55rem;
}

/* ── Item Card ── */
.launcher-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.45rem;
  padding: 0.85rem 0.5rem 0.75rem;
  background: var(--bg-toolbar, rgba(255,255,255,.03));
  border: 1.5px solid var(--border, rgba(255,255,255,.07));
  border-radius: 12px;
  cursor: pointer;
  text-align: center;
  transition: all 0.18s ease;
  position: relative;
  font-family: inherit;
  text-decoration: none;
  color: var(--text-secondary, rgba(255,255,255,.55));
}

.launcher-item:hover {
  background: var(--bg-surface, #0d0f1a);
  border-color: var(--item-color, #3b82f6);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.4);
  transform: translateY(-2px);
  color: var(--text-primary, #e2e8f0);
}

.launcher-item:hover .launcher-item-icon-wrap {
  background: var(--item-color, #3b82f6);
}

.launcher-item:hover .launcher-item-icon-wrap svg {
  color: #fff;
}

.launcher-item:active {
  transform: translateY(0);
}

.launcher-item.not-implemented {
  opacity: 0.55;
  cursor: default;
}

.launcher-item.is-recent {
  border-color: var(--border, rgba(255,255,255,.14));
  background: var(--bg-toolbar, rgba(255,255,255,.05));
}

.launcher-item-icon-wrap {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: var(--bg-input, rgba(255,255,255,.06));
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.18s;
  flex-shrink: 0;
}

.launcher-item-icon {
  width: 20px;
  height: 20px;
  color: var(--text-primary, #e2e8f0);
  transition: color 0.18s;
}

.launcher-item-label {
  font-size: 0.72rem;
  font-weight: 500;
  line-height: 1.3;
  color: inherit;
  word-break: break-word;
  hyphens: auto;
}

.launcher-item-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  font-size: 0.65rem;
  line-height: 1;
}

/* ── No results ── */
.launcher-no-results {
  grid-column: 1 / -1;
  text-align: center;
  color: var(--text-muted, rgba(255,255,255,.35));
  font-size: 0.9rem;
  padding: 1.5rem 0;
}

/* ── Responsive ── */
@media (max-width: 600px) {
  .app-launcher-panel {
    width: 100vw;
    height: 100dvh;
    max-height: 100dvh;
    margin-top: 0;
    border-radius: 0;
  }

  .launcher-grid {
    grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AppLauncher.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,sDAAsD;EACtD,mBAAmB;EACnB,yEAAyE;EACzE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,wCAAwC;EACxC,6DAA6D;AAC/D;;AAEA;EACE,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,6DAA6D;EAC7D,oDAAoD;EACpD,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kDAAkD;EAClD,wDAAwD;EACxD,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;AACjD;;AAEA,wCAAwC;AACxC;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mDAAmD;EACnD,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,wDAAwD;EACxD,kBAAkB;EAClB,eAAe;EACf,mDAAmD;EACnD,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;EAC/C,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,oDAAoD;EACpD,wDAAwD;EACxD,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,yCAAyC;EACzC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kDAAkD;EAClD,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE;IACE,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,2DAA2D;EAC7D;AACF","sourcesContent":["/**\r\n * AppLauncher - Odoo-style organized module launcher\r\n * Full-screen overlay with domain-grouped grid navigation\r\n */\r\n\r\n/* ── Overlay ── */\r\n.app-launcher-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 2000;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  pointer-events: none;\r\n  opacity: 0;\r\n  transition: opacity 0.2s ease;\r\n}\r\n\r\n.app-launcher-overlay.open {\r\n  pointer-events: all;\r\n  opacity: 1;\r\n}\r\n\r\n/* Backdrop */\r\n.app-launcher-backdrop {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: rgba(15, 23, 42, 0.55);\r\n  backdrop-filter: blur(4px);\r\n}\r\n\r\n/* ── Panel ── */\r\n.app-launcher-panel {\r\n  position: relative;\r\n  z-index: 1;\r\n  width: min(860px, 96vw);\r\n  max-height: 88vh;\r\n  margin-top: 5vh;\r\n  background: var(--bg-surface, #0d0f1a);\r\n  border: 1px solid var(--border, rgba(255,255,255,.07));\r\n  border-radius: 16px;\r\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5), 0 4px 16px rgba(0, 0, 0, 0.3);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  transform: translateY(-12px) scale(0.98);\r\n  transition: transform 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);\r\n}\r\n\r\n.app-launcher-overlay.open .app-launcher-panel {\r\n  transform: translateY(0) scale(1);\r\n}\r\n\r\n/* ── Header ── */\r\n.launcher-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding: 1rem 1.25rem;\r\n  border-bottom: 1px solid var(--border, rgba(255,255,255,.07));\r\n  background: var(--bg-toolbar, rgba(255,255,255,.03));\r\n  flex-shrink: 0;\r\n}\r\n\r\n.launcher-search-wrap {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: var(--bg-input, rgba(255,255,255,.05));\r\n  border: 1.5px solid var(--border, rgba(255,255,255,.12));\r\n  border-radius: 10px;\r\n  padding: 0 0.75rem;\r\n  transition: border-color 0.15s;\r\n}\r\n\r\n.launcher-search-wrap:focus-within {\r\n  border-color: var(--accent, #6366f1);\r\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);\r\n}\r\n\r\n.launcher-search-icon {\r\n  width: 18px;\r\n  height: 18px;\r\n  color: var(--text-muted, rgba(255,255,255,.35));\r\n  flex-shrink: 0;\r\n}\r\n\r\n.launcher-search-input {\r\n  flex: 1;\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  font-size: 0.95rem;\r\n  color: var(--text-primary, #e2e8f0);\r\n  padding: 0.55rem 0;\r\n  font-family: inherit;\r\n}\r\n\r\n.launcher-search-input::placeholder {\r\n  color: var(--text-muted, rgba(255,255,255,.35));\r\n}\r\n\r\n/* Remove default search cancel button */\r\n.launcher-search-input::-webkit-search-cancel-button {\r\n  display: none;\r\n}\r\n\r\n.launcher-search-clear {\r\n  background: none;\r\n  border: none;\r\n  padding: 2px;\r\n  cursor: pointer;\r\n  color: var(--text-muted, rgba(255,255,255,.35));\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 4px;\r\n  transition: color 0.15s, background 0.15s;\r\n}\r\n\r\n.launcher-search-clear:hover {\r\n  color: var(--text-secondary, rgba(255,255,255,.55));\r\n  background: var(--bg-toolbar, rgba(255,255,255,.08));\r\n}\r\n\r\n.launcher-search-clear svg {\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n\r\n.launcher-close-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  background: none;\r\n  border: 1.5px solid var(--border, rgba(255,255,255,.12));\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  color: var(--text-secondary, rgba(255,255,255,.55));\r\n  flex-shrink: 0;\r\n  transition: all 0.15s;\r\n}\r\n\r\n.launcher-close-btn:hover {\r\n  background: rgba(239,68,68,.15);\r\n  border-color: #ef4444;\r\n  color: #fca5a5;\r\n}\r\n\r\n.launcher-close-btn svg {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n/* ── Body ── */\r\n.launcher-body {\r\n  overflow-y: auto;\r\n  padding: 1.25rem 1.25rem 1.5rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.launcher-body::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.launcher-body::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.launcher-body::-webkit-scrollbar-thumb {\r\n  background: var(--border, rgba(255,255,255,.14));\r\n  border-radius: 3px;\r\n}\r\n\r\n/* ── Sections ── */\r\n.launcher-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.65rem;\r\n}\r\n\r\n.launcher-section-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  color: var(--text-muted, rgba(255,255,255,.35));\r\n  letter-spacing: 0.8px;\r\n  text-transform: uppercase;\r\n  padding-bottom: 0.35rem;\r\n  border-bottom: 1px solid var(--border, rgba(255,255,255,.07));\r\n}\r\n\r\n.launcher-section-label.recents {\r\n  color: var(--text-secondary, rgba(255,255,255,.55));\r\n}\r\n\r\n.section-label-icon {\r\n  width: 13px;\r\n  height: 13px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.section-label-dot {\r\n  display: inline-block;\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: var(--domain-color, #94a3b8);\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ── Grid ── */\r\n.launcher-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));\r\n  gap: 0.55rem;\r\n}\r\n\r\n/* ── Item Card ── */\r\n.launcher-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.45rem;\r\n  padding: 0.85rem 0.5rem 0.75rem;\r\n  background: var(--bg-toolbar, rgba(255,255,255,.03));\r\n  border: 1.5px solid var(--border, rgba(255,255,255,.07));\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  transition: all 0.18s ease;\r\n  position: relative;\r\n  font-family: inherit;\r\n  text-decoration: none;\r\n  color: var(--text-secondary, rgba(255,255,255,.55));\r\n}\r\n\r\n.launcher-item:hover {\r\n  background: var(--bg-surface, #0d0f1a);\r\n  border-color: var(--item-color, #3b82f6);\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.4);\r\n  transform: translateY(-2px);\r\n  color: var(--text-primary, #e2e8f0);\r\n}\r\n\r\n.launcher-item:hover .launcher-item-icon-wrap {\r\n  background: var(--item-color, #3b82f6);\r\n}\r\n\r\n.launcher-item:hover .launcher-item-icon-wrap svg {\r\n  color: #fff;\r\n}\r\n\r\n.launcher-item:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.launcher-item.not-implemented {\r\n  opacity: 0.55;\r\n  cursor: default;\r\n}\r\n\r\n.launcher-item.is-recent {\r\n  border-color: var(--border, rgba(255,255,255,.14));\r\n  background: var(--bg-toolbar, rgba(255,255,255,.05));\r\n}\r\n\r\n.launcher-item-icon-wrap {\r\n  width: 42px;\r\n  height: 42px;\r\n  border-radius: 10px;\r\n  background: var(--bg-input, rgba(255,255,255,.06));\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background 0.18s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.launcher-item-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n  color: var(--text-primary, #e2e8f0);\r\n  transition: color 0.18s;\r\n}\r\n\r\n.launcher-item-label {\r\n  font-size: 0.72rem;\r\n  font-weight: 500;\r\n  line-height: 1.3;\r\n  color: inherit;\r\n  word-break: break-word;\r\n  hyphens: auto;\r\n}\r\n\r\n.launcher-item-badge {\r\n  position: absolute;\r\n  top: 6px;\r\n  right: 6px;\r\n  font-size: 0.65rem;\r\n  line-height: 1;\r\n}\r\n\r\n/* ── No results ── */\r\n.launcher-no-results {\r\n  grid-column: 1 / -1;\r\n  text-align: center;\r\n  color: var(--text-muted, rgba(255,255,255,.35));\r\n  font-size: 0.9rem;\r\n  padding: 1.5rem 0;\r\n}\r\n\r\n/* ── Responsive ── */\r\n@media (max-width: 600px) {\r\n  .app-launcher-panel {\r\n    width: 100vw;\r\n    height: 100dvh;\r\n    max-height: 100dvh;\r\n    margin-top: 0;\r\n    border-radius: 0;\r\n  }\r\n\r\n  .launcher-grid {\r\n    grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
